import React, { ReactElement } from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Meta } from '@storybook/react'
import InputComponent from '../Input'

export default {
    title: 'Components/UI/FormElements/Input',
    component: InputComponent,
} as Meta

export function Input({ ...args }): ReactElement {
    return <InputComponent label="Input label" required={false} {...args} />
}

export function InputRequired({ ...args }): ReactElement {
    return <InputComponent label="Input label" required {...args} />
}
